import axios from 'axios'
import { getHeaderUser, appUser } from '@/utils/auth'
import { $toAppLogin } from '@/utils/common/native-api'
import { vconsole_log } from '@/utils'
export function print_options({ config, headUser }) {
  const options = [
    '------------请求开始------------',
    { name: 'url', param: [config.url, config.method] },
    { name: 'headers', param: headUser },
    { name: 'request data', param: config.data },
    '------------END------------'
  ]
  // console.log('请求头', options.map(print_param).join('\n'))
  vconsole_log('请求头', options.map(print_param).join('\n'))
}
function print_param(options) {
  if (typeof options === 'string') return options
  const { name, param } = options
  return `[${name}]` + '\n' + JSON.stringify(param, 0, 2)
}

// 接口授权参数常量
const baseURL = process.env.VUE_APP_BASE_API // url = base url + request url

// create an axios instance
const service = axios.create({
  baseURL,
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 * 20 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (config.data && config.data.dailyUserId) {
      appUser.userId = config.data.dailyUserId
      delete config.data.dailyUserId
    }
    const headUser = getHeaderUser(config.data, { uuid: true }) // 附带请求检查
    if (headUser) {
      // 打印日志
      // print_options({ config, headUser })
      if (config.data && config.data.userId) {
        headUser.userId = config.data.userId // 测试用户ID
      }
      // 用户的Token信息
      Object.keys(headUser).forEach(userKey => {
        config.headers[userKey] = headUser[userKey]
      })
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor 拦截器
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    console.log(response)
    const res = response.data
    // 有特定错误码时，先进行处理，其他错误码在业务中自行处理
    if (errorCodes.indexOf(res.code) >= 0) {
      errorException({ response })
      return Promise.reject(res)
    }
    // code 不为 0时，为错误提示，会自动提示错误信息
    if (res.code !== 0) {
      return Promise.reject(res)
    }

    // 请求成功时，解开 res.data，直接使用
    return res && res.data // 返回请求的数据
  },
  error => {
    return Promise.reject(error)
  }
)

// import { isInnerUser } from '@/pages/config'
import { pageArgs } from '@/utils'

/**
 * 服务器异常
 * @param {Object} response
 * @returns 是否需要错误提示
 */
export function errorException(error) {
  console.log(error, 'request error')
  const { response } = error
  const res = response.data
  // const req = response.request
  const { code } = res

  // 服务器异常
  if (code === 50000) {
    return service({
      url: 'errorUpload',
      method: 'get',
      headers: {
        referer: ''
      },
      params: { code }
    })
  } else if (userErrorCodes.indexOf(code) >= 0) {
    let a = JSON.parse(JSON.stringify(appUser))
    console.log(a, appUser, appUser.token, !appUser.token, 'appUserappUser')
    // 清除token & 跳转到登录
    if (appUser.isNative) {
      $toAppLogin()
    } else if (appUser.token) {
      appUser.resetToken()
      console.log('appUser.resetToken() 清除token')
      if (pageArgs.args().errorToken === undefined) {
        location.reload()
      } else {
        console.log('location.reload() 不执行')
      }
    } else {
      console.log('----------')
    }
  }
}

const userErrorCodes = [10001]

const errorCodes = [
  ...userErrorCodes,
  50000, // 服务器异常
  40108, // 鉴权已过期
  40104 // invalid signature 非法请求签名
]

// 异步请求方法
export * from './request-async' // AsyncRequest
export default service
